import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._b({attrs:{"loading":_vm.isLoading},on:{"click":_vm.fetch}},'v-btn',_vm.vBtnProps,false),[_vm._v("\n  "+_vm._s(_vm.$t('pages.transfers.facebookConversation'))+"\n  "),_c(VIcon,{attrs:{"right":""}},[_vm._v("mdi-open-in-new")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }